import { getEnv } from '@shared/utils/env';
import { format } from 'date-fns';
import request from '@services/request';

const VITE_TRANSFERS_REPORT_VERSION = getEnv().VITE_TRANSFERS_REPORT_VERSION;

const apiVersion = VITE_TRANSFERS_REPORT_VERSION === '2' ? 'v2' : 'v1';

const getTransfersByParams = async (search, fetchAll = 0, page = 0, size = 3, rotative = false, sortBy = '', sortOrder = '') => {
  const params = {
    id: search.transfer_id || null,
    date_from: search.date_from ? format(search.date_from, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
    date_to: search.date_to ? format(search.date_to, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
    cash_register_id: search.cash_register_id || null,
    transaction_id: search.transaction_id || null,
    correspondent_name: search.correspondent_name ?? '',
    subsidiary_name: search.subsidiary_name ?? '',
    cashier_name: search.cashier_name ?? '',
    cellphone: search.client_phone ?? '',
    cash_register_open: search.cashOpen ?? '',
    subsidiary_identification: search.subsidiary_id || (search.subsidiary_id === 0 ? 0 : null),
    profile_identification: search.profile_id || null,
    limit: size,
    offset: page,
    fetchAll,
    sortBy: sortBy ?? '',
    sortOrder: sortOrder ?? '',
  };
  if (rotative) {
    delete params.subsidiary_identification;
  }
  const endpoint = `/api/${apiVersion}/corresponsal/reports/transfers`;
  const result = await request.get(endpoint, params);
  const { data } = result;
  return data;
};

const getBalanceByParams = async (search) => {
  const params = {
    date_from: search.date_from ? format(search.date_from, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
    date_to: search.date_to ? format(search.date_to, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
    subId: search.subId ?? '',
    profileId: search.profileId ?? '',
    open_register: search?.cashOpen ?? '',
    cash_register_id: search?.cash_register_id ?? '',
  };
  const result = await request.get(`/api/${apiVersion}/corresponsal/reports/transfers/balance`, params);
  const { data } = result;
  return data;
};

const updateTransferService = async (hashId) => {
  const result = await request.put(`/api/v1/corresponsal/transfers/${hashId}`);
  const { data } = result;
  return data;
};

const getNotificationsByTransferId = async (transferId) => {
  const params = {
    transferId,
  };
  const result = await request.get('/api/v1/corresponsal/notificationsByTransferId', params);
  const { data } = result;
  return data;
};

export { getBalanceByParams, getNotificationsByTransferId, getTransfersByParams, updateTransferService };
